// Pobieranie zawartości wątku czatu (polling)

import { orionAxios } from '../orionApi';
import { ChatResponse } from './orionTypes';

/**
 * Pobiera zawartość wątku - używane w pętli pollingu do otrzymywania odpowiedzi AI
 * @param threadId - UUID wątku
 * @param includeDetails - czy includować szczegóły (1) czy nie (0)
 * @param lastTurnId - ID ostatniej tury lub 'none'
 * @param contentHash - hash zawartości lub 'none'
 * @returns chunk HTML z odpowiedzią, isDone flag, fromTurnId dla inkrementalnych aktualizacji
 */
export const getThreadContent = async (
  threadId: string,
  includeDetails: number,
  lastTurnId: string,
  contentHash: string
): Promise<ChatResponse> => {
  const response = await orionAxios.get<ChatResponse>(
    `/api/aiassistant/get-thread-content/${threadId}/${includeDetails}/${encodeURIComponent(
      lastTurnId
    )}/${encodeURIComponent(contentHash)}`
  );
  return response.data;
};

